import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { GenieLoader } from "@/components/ui/GenieLoader";
import { useSelectableAgents } from "@/hooks/agent";

// Genie Access now lives inside each Genie's Activation Pack ("Invite people").
// This page only exists to forward old links (bookmarks, sent emails) to the
// right place.
export default function GenieAccessPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { data: agents, isLoading } = useSelectableAgents();

  useEffect(() => {
    if (isLoading) return;
    const genieName = searchParams.get("genie");
    const match = genieName ? agents?.find((a: any) => a.name === genieName) : null;

    if (match) {
      navigate(`/genie-hub/activation/genie/${match.id}#activate-invite`, { replace: true });
    } else {
      toast.info("Invite people now lives on each Genie's Activation Pack — pick a Genie to invite to.");
      navigate("/genie-hub/my-genies", { replace: true });
    }
  }, [isLoading, agents, searchParams, navigate]);

  return <GenieLoader size="fullscreen" loadingText="Taking you to your Genies…" />;
}
